import { observable, action, runInAction } from 'mobx'
import { get } from '../../../../../utils/ajax'

class MainTainCarSeriesStore {
  @observable loading
  @observable list
  @observable page

  constructor () {
    this.loading = false
    this.list = []
    this.page = {
      current: 1,
      total: 1,
      search: ''
    }
  }

  @action
  initList = async (page) => {
    runInAction(() => {
      this.loading = true
    })
    if (page) {
      page--
    } else if (this.page.current) {
      page = this.page.current - 1
    } else {
      page = 0
    }
    let search = this.page.search || ''
    const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/carseriesAuths`, {
      'page': page.toString(),
      'carseriesName': search,
      'size': 100
    })
    if (res && res.status === 0) {
      return
    }
    runInAction(() => {
      res.content && (this.list = res.content)
      this.page = {
        current: res.number + 1,
        total: res.totalElements
      }
      this.loading = false
    })
  }

}

export default new MainTainCarSeriesStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/web/maintain/CarSeries/store.js